import React from 'react'
import PartnerHome from './PartnerHome';
import ContactForm from '../Franchise/ContactForm';
import HowItWorks from './HowItWorks';
import OurFranchise from './FranchiseOwners';

function FranchiseComponent() {
  return (
    <div>
      <PartnerHome/>
      <ContactForm/>
      <HowItWorks/>
      <OurFranchise/>
    </div>
  )
}

export default FranchiseComponent